import { assignSupportRequest } from './assignSupportRequest'
import { claimNextSupportRequest } from './claimNextSupportRequest'
import { createPublicSupportRequest } from './createPublicSupportRequest'
import { createSupportRequest } from './createSupportRequest'
import { getDetailByNumber } from './getDetailByNumber'
import { getSupportTeam } from './getSupportTeam'
import { getSupportRequestCounts } from './getSupportRequestCounts'
import { getSupportRequestsChart } from './getSupportRequestsChart'
import { getSupportAttendanceStats } from './getSupportAttendanceStats'
import { getSupportOverviewStats } from './getSupportOverviewStats'
import { getSupportReasons } from './getSupportReasons'
import { listSupportRequests } from './listAllSupport'
import { replySupportRequest } from './replySupportRequest'
import { updateSupportRequest } from './updateSupportRequest'
import { uploadSupportAttachments } from './uploadSupportAttachments'

export const supportRequestService = {
  listSupportRequests,
  getDetailByNumber,
  getSupportRequestsChart,
  getSupportAttendanceStats,
  getSupportOverviewStats,
  getSupportRequestCounts,
  replySupportRequest,
  updateSupportRequest,
  claimNextSupportRequest,
  assignSupportRequest,
  getSupportTeam,
  getSupportReasons,
  createSupportRequest,
  createPublicSupportRequest,
  uploadSupportAttachments,
}
